import React from 'react';
import { PortalOverlay, Pane, Content, Button, Flex, Text } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import S from './ErrorGeneric.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.imagine.forms.ErrorGeneric');
export class ErrorGeneric extends React.Component {
  static defaultProps = {
    titleVariant: 'dialogTitle',
    get title() {
      return t('title');
    },
    get titleIcon() {
      return tIcon('editIcon', 'fa fa-pencil fa-fw');
    },
    eventData: null,
    get submitText() {
      return t('submitText');
    },
    get cancelText() {
      return t('cancelText');
    }
  };
  constructor(props) {
    super(props);
    this.state = {
      breakpoint: this.getBreakpoint(window?.innerWidth)
    };
  }
  getBreakpoint(size) {
    return size > Config.get('ResponsiveUtility', 'smallBreakpoint', 1024) ? 'big' : 'small';
  }
  onRetry = () => {
    const {
      onRetry
    } = this.props;
    onRetry();
  };
  onCancel = () => {
    const {
      onCancel
    } = this.props;
    onCancel?.();
  };
  renderBody() {
    const {
      variant,
      headerVariant,
      bodyVariant,
      footerVariant,
      titleVariant,
      title,
      titleIcon,
      cancelText,
      submitText
    } = this.props;
    const {
      breakpoint
    } = this.state;
    const vnt = variant || (breakpoint === 'small' ? 'mobileItemForm' : 'itemForm');
    const headerVnt = headerVariant || (breakpoint === 'small' ? 'mobileItemFormHeader' : 'itemFormHeader');
    const bodyVnt = bodyVariant || (breakpoint === 'small' ? 'mobileItemFormBody' : 'itemFormBody');
    const footerVnt = footerVariant || (breakpoint === 'small' ? 'mobileItemFormFooter' : 'itemFormFooter');
    const errorImage = Config.get('ErrorScreen', 'image', 'https://storage.googleapis.com/molten-ui-assets/error-screen-illustraion.png');
    const errorImageDimensions = Config.get('ErrorScreen', 'image/dimensions', {
      height: 128,
      width: 182
    });
    const errorTitle = Config.get('ErrorScreen', 'text/title', t('errorTitle'));
    const errorBody = Config.get('ErrorScreen', 'text/body', t('errorBody'));
    return /*#__PURE__*/_jsx(Pane, {
      variant: vnt,
      children: /*#__PURE__*/_jsxs(Content, {
        relative: breakpoint === 'big',
        children: [/*#__PURE__*/_jsx(Content.Header, {
          variant: `${headerVnt}|formHeader`,
          children: /*#__PURE__*/_jsx(TitleBar, {
            variant: titleVariant,
            title: title,
            icon: titleIcon
          })
        }), /*#__PURE__*/_jsx(Content.Area, {
          variant: `${bodyVnt}|formBody`,
          className: S.form,
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "colL",
            children: [/*#__PURE__*/_jsx("img", {
              className: S.image,
              src: errorImage,
              alt: "error",
              height: errorImageDimensions.height,
              width: errorImageDimensions.width
            }), /*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: errorTitle
            }), /*#__PURE__*/_jsx(Text, {
              children: errorBody
            })]
          })
        }), /*#__PURE__*/_jsxs(Content.Footer, {
          variant: `${footerVnt}|formButtons`,
          layout: "flex:rowMEnd",
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "secondary",
            onClick: this.onCancel,
            children: cancelText
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            onClick: this.onRetry,
            children: submitText
          })]
        })]
      })
    });
  }
  render() {
    const {
      show,
      onClose
    } = this.props;
    return /*#__PURE__*/_jsx(PortalOverlay, {
      position: "center",
      show: show,
      closeOnEscape: false,
      closeOnDocumentClick: false,
      onClose: onClose,
      children: this.renderBody()
    });
  }
}
export default {
  id: 'molten.BlueprintFormError.generic',
  sort: 'zzz',
  component: ErrorGeneric
};